import { Route, Switch } from "wouter";
import { WelcomePage } from "./pages/Welcome";
import { JoinPage } from "./pages/Join";
import { SignupPage } from "./pages/Signup";
import { LoginPage } from "./pages/Login";
import { CardsPage } from "./pages/Cards";
import { DiscoverPage } from "./pages/Discover";
import { ProfilePage } from "./pages/Profile";
import { ProfileEditPage } from "./pages/ProfileEdit";
import { ProfilePhoneChangePage } from "./pages/ProfilePhoneChange";
import { ProfileEmailChangePage } from "./pages/ProfileEmailChange";
import { ProfileConnectedMerchantsPage } from "./pages/ProfileConnectedMerchants";
import { ProfileConsentHistoryPage } from "./pages/ProfileConsentHistory";
import { ProfileDataExportPage } from "./pages/ProfileDataExport";
import { ProfileAccountDeletePage } from "./pages/ProfileAccountDelete";
import { ProfileNotificationsPage } from "./pages/ProfileNotifications";
import { ProfileVehiclesPage } from "./pages/ProfileVehicles";
import { VerifyEmailPage } from "./pages/VerifyEmail";
// Phase 31 (D103) — forgot-password (3-step) + set/change password.
import { ForgotPasswordPage } from "./pages/ForgotPassword";
import { ForgotPasswordVerifyPage } from "./pages/ForgotPasswordVerify";
import { SetPasswordPage } from "./pages/SetPassword";
import { MerchantLoginPage } from "./pages/MerchantLogin";
import { MerchantSettingsPage } from "./pages/MerchantSettings";
import { MerchantRewardsPage } from "./pages/MerchantRewards";
import { MerchantRedeemPage } from "./pages/MerchantRedeem";
import { MerchantDetailPage } from "./pages/MerchantDetail";
import { MerchantTransactionsPage } from "./pages/MerchantTransactions";
import { MerchantTransactionDetailPage } from "./pages/MerchantTransactionDetail";
import { MerchantCustomersPage } from "./pages/MerchantCustomers";
import { MerchantCustomerDetailPage } from "./pages/MerchantCustomerDetail";
import { MerchantDashboardPage } from "./pages/MerchantDashboard";
import { MerchantMarketplaceImportPage } from "./pages/MerchantMarketplaceImport";
import { MerchantMarketplaceCodesPage } from "./pages/MerchantMarketplaceCodes";
import { MerchantInboxPage } from "./pages/MerchantInbox";
import { MerchantSurprisePoolPage } from "./pages/MerchantSurprisePool";
import { MerchantStreakSettingsPage } from "./pages/MerchantStreakSettings";
import { MerchantPlansPage } from "./pages/MerchantPlans";
import { MerchantSmsCreditsPage } from "./pages/MerchantSmsCredits";
import { MerchantTeamPage } from "./pages/MerchantTeam";
import { MerchantTokenRecoveryPage } from "./pages/MerchantTokenRecovery";
import { MerchantTokenRecoveryVerifyPage } from "./pages/MerchantTokenRecoveryVerify";
// Phase 28 — public standalone-tenant self-serve onboarding.
import { ForMerchantsPage } from "./pages/ForMerchants";
import { MerchantSignupPage } from "./pages/MerchantSignup";
import { MerchantSignupVerifyPage } from "./pages/MerchantSignupVerify";
import { MerchantSignupCompletePage } from "./pages/MerchantSignupComplete";
import { ClaimEntryPage } from "./pages/Claim";
import { ClaimCodePage } from "./pages/ClaimCode";
import { VoucherPage } from "./pages/Voucher";
import { VouchersPage } from "./pages/Vouchers";
import { InboxPage } from "./pages/Inbox";
import { InboxMessagePage } from "./pages/InboxMessage";
import { RecapPage } from "./pages/Recap";
import HelpPage from "./pages/Help";
import MerchantHelpPage from "./pages/MerchantHelp";

export function App() {
  return (
    <Switch>
      <Route path="/" component={WelcomePage} />
      <Route path="/j/:tenantShortCode" component={JoinPage} />
      <Route path="/signup" component={SignupPage} />
      <Route path="/login" component={LoginPage} />
      <Route path="/cards" component={CardsPage} />
      {/* Phase 9 — per-merchant card detail (balance + rewards + activity). */}
      <Route path="/cards/:tcId" component={MerchantDetailPage} />
      <Route path="/discover" component={DiscoverPage} />

      {/* Phase 12 — customer profile + connected merchants management.
          Sub-pages ordered identity → relationships → audit/data → delete. */}
      <Route path="/profile" component={ProfilePage} />
      <Route path="/profile/edit" component={ProfileEditPage} />
      <Route path="/profile/phone-change" component={ProfilePhoneChangePage} />
      <Route path="/profile/email-change" component={ProfileEmailChangePage} />
      <Route
        path="/profile/connected-merchants"
        component={ProfileConnectedMerchantsPage}
      />
      <Route path="/profile/consents" component={ProfileConsentHistoryPage} />
      <Route path="/profile/data-export" component={ProfileDataExportPage} />
      <Route
        path="/profile/account-delete"
        component={ProfileAccountDeletePage}
      />
      {/* Phase 18 — push notification settings (status, devices, test). */}
      <Route
        path="/profile/notifications"
        component={ProfileNotificationsPage}
      />
      {/* Phase 26 — customer plate registration (display/personalization
          metadata, capped at 5 plates per customer). */}
      <Route path="/profile/vehicles" component={ProfileVehiclesPage} />
      <Route path="/verify-email" component={VerifyEmailPage} />
      {/* Phase 31 (D103) — public forgot-password 3-step + the
          authenticated set/change page used both after signup-via-join
          (where the customer was created passwordless) and from the
          profile hub. */}
      <Route path="/forgot-password" component={ForgotPasswordPage} />
      <Route
        path="/forgot-password/verify"
        component={ForgotPasswordVerifyPage}
      />
      <Route path="/set-password" component={SetPasswordPage} />

      {/* Phase 9 customer voucher surfaces. */}
      <Route path="/profile/vouchers" component={VouchersPage} />
      <Route path="/vouchers/:redemptionId" component={VoucherPage} />

      {/* Phase 15 — in-app inbox. List + single message detail. */}
      <Route path="/inbox" component={InboxPage} />
      <Route path="/inbox/:id" component={InboxMessagePage} />
      {/* Phase 21 — monthly recap + Year-in-Review detail page. */}
      <Route path="/recap/:recapId" component={RecapPage} />
      {/* Merchant dashboard surfaces. Today: "scan settings"
          (Task #25), Phase 9 rewards CRUD + voucher redeem. */}
      <Route path="/merchant" component={MerchantLoginPage} />
      <Route path="/merchant/login" component={MerchantLoginPage} />
      {/* Phase 13 — merchant analytics home (today's stats + recent activity). */}
      <Route path="/merchant/dashboard" component={MerchantDashboardPage} />
      <Route path="/merchant/settings" component={MerchantSettingsPage} />
      <Route path="/merchant/rewards" component={MerchantRewardsPage} />
      <Route path="/merchant/redeem" component={MerchantRedeemPage} />
      {/* Phase 11 — merchant transaction management surfaces. */}
      <Route path="/merchant/transactions" component={MerchantTransactionsPage} />
      <Route
        path="/merchant/transactions/:id"
        component={MerchantTransactionDetailPage}
      />
      <Route path="/merchant/customers" component={MerchantCustomersPage} />
      <Route
        path="/merchant/customers/:tcId/:customerId"
        component={MerchantCustomerDetailPage}
      />
      {/* Phase 14 — marketplace claim-code surfaces. */}
      <Route
        path="/merchant/marketplace"
        component={MerchantMarketplaceImportPage}
      />
      <Route
        path="/merchant/marketplace/codes"
        component={MerchantMarketplaceCodesPage}
      />
      {/* Phase 15 — merchant inbox composer + sent history. */}
      <Route path="/merchant/inbox" component={MerchantInboxPage} />
      {/* Phase 19 — surprise-card pool admin (one pool per tenant). */}
      <Route path="/merchant/surprises" component={MerchantSurprisePoolPage} />
      {/* Phase 20 — per-tenant streak engine + milestone toggles. */}
      <Route path="/merchant/streaks" component={MerchantStreakSettingsPage} />
      {/* Phase 34 — subscription tier menu + change requests (D107). */}
      <Route path="/merchant/plans" component={MerchantPlansPage} />
      <Route path="/merchant/sms-credits" component={MerchantSmsCreditsPage} />
      <Route path="/merchant/team" component={MerchantTeamPage} />
      {/* Phase 17 — self-serve tenant token recovery (D53). Both
          routes are unauthenticated — they predate the merchant
          having a token to authenticate with. */}
      <Route path="/merchant/recover" component={MerchantTokenRecoveryPage} />
      <Route
        path="/merchant/recover/verify"
        component={MerchantTokenRecoveryVerifyPage}
      />
      {/* Phase 28 — public standalone-tenant self-serve onboarding.
          The four pages share a sessionStorage attemptToken (in
          MerchantSignup.tsx) and end with setMerchantToken() →
          /merchant/dashboard auto-login (D94). All routes are
          deliberately unauthenticated — the merchant predates having
          a token here too. */}
      <Route path="/for-merchants" component={ForMerchantsPage} />
      <Route path="/merchant/signup" component={MerchantSignupPage} />
      <Route
        path="/merchant/signup/verify"
        component={MerchantSignupVerifyPage}
      />
      <Route
        path="/merchant/signup/complete"
        component={MerchantSignupCompletePage}
      />
      <Route path="/claim" component={ClaimEntryPage} />
      <Route path="/claim/:code" component={ClaimCodePage} />
      {/* Customer how-to-use manual (FAQ-style) and merchant
          dashboard manual. Both are static content pages reachable
          from the in-app nav (Profile → Help, MerchantNav → Help). */}
      <Route path="/help" component={HelpPage} />
      <Route path="/merchant/help" component={MerchantHelpPage} />
      <Route>
        <div className="min-h-screen flex flex-col items-center justify-center px-6 text-center">
          <h1 className="text-3xl font-bold text-navy">Page not found</h1>
          <p className="mt-2 text-ink-dark">That route doesn't exist.</p>
          <a href="/" className="mt-6 text-navy underline">
            Back to start
          </a>
        </div>
      </Route>
    </Switch>
  );
}
